import { ApplicationStore, ApplicationStoreProps } from "@ctypes";
import { create } from "zustand";

export const useApplicationStore = create<ApplicationStore>((set) => ({
  applicationProps: { tokenExpired: false },
  setApplicationProps: (applicationProps: ApplicationStoreProps) =>
    set(() => ({ applicationProps })),
}));
